<template>
  <div class="inventory--documents-tab animated fadeIn">
    <Documents
      :parentId="partId"
      :service="documentsService"
      :fileTypes="fileTypes"
    ></Documents>
  </div>
</template>

<script>

import inventoryDocumentService from './service';

export default {
  data() {
    return {
      fileTypes: ['.txt', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.png', '.jpg', '.jpeg', '.gif', '.csv', '.ppt', '.pptx'].join(', '),
      documentsService: inventoryDocumentService
    }
  },
  computed: {
    partId: function() {
      return this.$route.params.partId;
    }
  }
}
</script>

<style lang="scss">
.inventory--documents-tab {
  table {
    margin-top: 1rem;
  }
}
</style>
